import React, { useEffect, useState, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { Form, Input, Spin } from 'antd';
import MaskedInput from 'antd-mask-input';
import { SaveOutlined, Visibility} from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router';
import { addDays } from 'date-fns';
import ButtonComponent from '@components/Shared/Buttons/Button';
import InvisibleContent from '@components/Shared/InvisibleContent';
import { MaskCPFeCNPJ } from '@utils/Masks';
import { LinkRoute } from '@src/Pages/Private/Cliente/shared/NovoCadastro/styles';
import { useParams } from 'react-router-dom';
import useDebounce from '@hooks/useDebounce';
import CheckExistsDocumentService from '@src/utils/CheckExistsDocumentService';

import ComponentPerfilServices, {
  IPessoaTriagem,
} from './services';

interface Iprops {
  perfilID: number;
  functionReload?: Function;
  verificaTriagem: boolean;
  idInteracao: number;
  idPessoa: number;
}

interface ICidade {
  id: string;
  label: string;
}

interface IRecorrencia {
  id: number;
  descricao: string;
}

interface IRecorrenciaPixCredito {
  intervalo_mes: number;
  descricao: string;
}
const DATA = addDays(new Date(), 0).toISOString().split('T')[0];

let dataNasc: string;
let pessoaId: number;
let idResponsavel: any;
let idIndicador: any;
let sexo: any;

const PerfilComponent: React.FC<Iprops> = ({
 // data,
  perfilID,
  functionReload,
  verificaTriagem,
  idInteracao,
  idPessoa
}) => {
  const [formRef] = Form.useForm();
  const { enqueueSnackbar } = useSnackbar();

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingCadastro, setLoadingCadastro] = useState(false);
  const [loadingEditPessoa, setLoadingEditPessoa] = useState(false);

  const [tipoDocumento, setTipoDocumento] = useState<'pf' | 'pj'>('pf');
  const [idExists, setIdExists] = useState(0);
  const [showButtonViewPessoa, setShowButtonViewPessoa] = useState(false);
  const { idCadastro }: { idCadastro: string } = useParams();

  function handleInput(e: any) {
    var ss = e.target.selectionStart;
    var se = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.selectionStart = ss;
    e.target.selectionEnd = se;
  };

  const loadPessoaTriagem = useCallback(async perfilID => {
    setLoadingCadastro(true);
    const services = new ComponentPerfilServices();
    const { error, response } = await services.GetPegaInformacoesFixasCadastro(perfilID);

    if (!error && response) {

      const { typeDocument, valueModify } = MaskCPFeCNPJ(
        response.documento,
      );


      setTipoDocumento(typeDocument);
      response.documento = valueModify;


      dataNasc = (response.data_nascimento).split('/').reverse().join('-');
      pessoaId = response.id_pessoa;
      idResponsavel = response.pessoa_responsavel;
      idIndicador = response.pessoa_indicador;
      sexo = response.sexo;


      const pessoaTriagem: IPessoaTriagem = {

        id_pessoa: response.id_pessoa,
        nome_pessoa: response.nome_pessoa,
        nome_fantasia: response.nome_fantasia,
        documento: response.documento,
        data_cadastro: response.data_cadastro,
        cadastrado_por: response.cadastrado_por,
        sexo: response.sexo,
        data_nascimento: response.data_cadastro,
        documento_indicador: response.documento_indicador,
        pessoa_responsavel: response.pessoa_responsavel,
        pessoa_indicador: response.pessoa_indicador,
        id_usuario_alteracao: response.id_usuario_alteracao,
        data_alteracao: response.data_alteracao,
      };


      formRef.setFieldsValue({
        nome_pessoa: response.nome_pessoa,
        nome_fantasia: response.nome_fantasia,
        documento: response.documento,
        data_cadastro: response.data_cadastro,
        cadastrado_por: response.cadastrado_por,
        sexo: response.sexo,
        data_nascimento: dataNasc,
        documento_indicador: response.documento_indicador,
        pessoa_responsavel: response.pessoa_responsavel,
        pessoa_indicador: response.pessoa_indicador,
        id_usuario_alteracao: response.id_usuario_alteracao,
        data_alteracao: response.data_alteracao,

      });
      setLoadingCadastro(false);
    } else {
      console.log('error', error);
    }
  }, []);

  async function onSubmit(values: any) {

    if (showButtonViewPessoa) {
      formRef.setFields([
        {
          name: 'documento',
          errors: ['Já existe uma pessoa cadastrada com esse documento'],
        },
      ]);
      return;
    }

    setLoadingEditPessoa(true);

    const services = new ComponentPerfilServices();
    console.log();
    const updatePessoaPerfilByPessoaIdResponse =
      await services.UpdatePessoaPerfilByPessoaId({
        pessoa: {
          data_nascimento: new Date(values.data_nascimento).toISOString(),
          documento: values.documento,
          id: pessoaId,
          nome: values.nome,
          nome_fantasia: values.nome_fantasia,
          sexo: sexo,
          id_pessoa_responsavel: idResponsavel,
          id_pessoa_indicador: idIndicador,
        },
      });

    if (!updatePessoaPerfilByPessoaIdResponse.error) {
      enqueueSnackbar(`Cadastro atualizado com sucesso!`, {
        title: 'Cadastro atualizado com sucesso!',
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        title: 'Ocorreu um erro ',
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      })
    }

    setLoadingEditPessoa(false);

  }


  const onChangeDocumento = (e: any) => {
    const value = e.target.value;

    const { typeDocument, valueModify } = MaskCPFeCNPJ(value);

    setTipoDocumento(typeDocument);

    formRef.setFieldsValue({
      documento: valueModify,
    });

    if (typeDocument === 'pj') {
      formRef.setFieldsValue({
        sexo: 1,
      });
    }
  };



  const checkDocument = (documento: string) => {
    const checkExistsDocumentService = new CheckExistsDocumentService();
    checkExistsDocumentService
      .checkDocument(documento)
      .then(({ error, response }) => {
        if (!error && response.id) {
          if (idCadastro === response.id.toString()) {
            return;
          }

          enqueueSnackbar(
            `Já existe uma pessoa cadastrada com esse documento`,
            {
              title: 'Já existe uma pessoa cadastrada com esse documento!',
              variant: 'warning',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            },
          );

          formRef.setFields([
            {
              name: 'documento',
              errors: ['Já existe uma pessoa cadastrada com esse documento'],
            },
          ]);
          setIdExists(response.id);
          setShowButtonViewPessoa(true);
          return;
        }
      });
    setShowButtonViewPessoa(false);
  };

  const debounceCheckDocument = useDebounce(checkDocument, 800);


  useEffect(() => {
    loadPessoaTriagem(perfilID);
  }, []);


  return (
    <Grid container>
      <Grid container item sm={12}>
        <Spin size="large" spinning={loadingUpdate} tip="Enviando dados...">

          {/*FORMULARIO */}



          <Form
           form={formRef}
           size="middle"
           layout="vertical"
           scrollToFirstError={true}
           onFinish={onSubmit}
           labelAlign="left"
           labelCol={{
             span: 24,
           }}
           wrapperCol={{
             span: 24,
           }}
           requiredMark={false}
           initialValues={{
            // cidade: { suggestion: suggestions[0] }
           //data_nascimento: dataNasci3,
           }}
          >
            <Grid
              container item sm={12} xs={12} lg={12}

              justify="center"
              alignItems="center"
              style={{paddingTop: 10}}
            >

              <Grid container justify="center" alignItems="center">
                {/* Tipo de Perfil */}
                {/* <Grid item lg={12} xs={12}>
                  <Form.Item
                    label="Tipo de perfil"
                    hasFeedback
                    name="nome"
                    rules={[{ required: true, message: 'Campo obrigatorio' }]}
                  >
                    <Input disabled placeholder="Tipo de perfil" />
                  </Form.Item>
                </Grid> */}
                {/* Tipo de Perfil */}

                {/* ORIGEM MACRO, ESPECIFICA e MOTIVO */}

                <Grid item lg={12} sm={12} xs={12}
                    style={{ paddingTop: 10}}
                  >
                    <Form.Item
                      label="Documento"
                      name="documento"
                      rules={[
                        { required: false, message: 'Campo obrigatorio' },
                        { min: 14, message: 'Minimo 14 caracteres' },
                        //{ validator: (e, a) => validaDocumento(e, a) },
                      ]}
                    >
                      <Input
                        maxLength={18}
                        onChange={(e: any) => {
                          onChangeDocumento(e);
                          debounceCheckDocument(e.target.value);
                        }}
                      />
                    </Form.Item>
                    {showButtonViewPessoa && (
                      <Grid item xs={12} lg={12} md={12}>
                        <LinkRoute
                          onClick={() => window.open(`/cadastro/${idExists}/`)}
                        >
                          Visualizar cadastro
                          <Visibility style={{ marginLeft: 10 }} />
                        </LinkRoute>
                      </Grid>
                    )}
                  </Grid>

                  <InvisibleContent
                  visible={tipoDocumento === 'pf'}
                >
<Grid item lg={12} sm={12} xs={12} style={{ marginTop: 10 }}>
<Form.Item
                      label='Nome'

                      name="nome_pessoa"
                      rules={[
                        { required: true, message: 'Campo obrigatorio' },
                        { min: 3, message: 'Minimo de 3 letras' },
                        {
                          pattern:  /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                          message: 'Somente letras'
                        }
                      ]}

                    >
                      <Input
                        onInput={handleInput}
                      />
                    </Form.Item>
                  </Grid>

                </InvisibleContent>

                <InvisibleContent
                  visible={tipoDocumento === 'pj'}
                >
<Grid item lg={12} sm={12} xs={12} style={{ marginTop: 10 }}>
                    <Form.Item
                      name="nome_pessoa"
                      label="Razão Social"
                      //hasFeedback
                      rules={[
                        { required: true, message: 'Campo obrigatorio' },
                        { min: 3, message: 'Minimo de 3 letras' },
                        {
                          pattern:  /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                          message: 'Somente letras'
                        }
                      ]}
                    >
                      <Input
                        onInput={handleInput}

                      />
                    </Form.Item>
                  </Grid>

                </InvisibleContent>





                {/* ORIGEM MACRO, ESPECIFICA e MOTIVO */}

                {/* { formaContribuicao, Valor e tipoCorrespondencia } */}
                <Grid container>
                <InvisibleContent
                  visible={tipoDocumento === 'pf'}
                >
                  <Grid item sm={6} xs={12}>

                    <Form.Item
                      name="nome_fantasia"
                      label="Nome Social"
                     // hasFeedback
                     rules={[
                      { required: true, message: 'Campo obrigatorio' },
                      { min: 3, message: 'Minimo de 3 letras' },
                      {
                        pattern:  /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                        message: 'Somente letras'
                      }
                    ]}
                    >
                     <Input
                        onInput={handleInput}

                      />
                    </Form.Item>



                  </Grid>

                  <Grid item sm={6} xs={12}>


                    <Form.Item
                      name="data_nascimento"
                      label="Data nascimento"
                      rules={[
                        {
                          required: true,
                          message: 'Selecione um tipo de correspondencia',
                        },
                      ]}
                    >
                     <Input
                          type="date"
                          max={DATA}
                          //mask="11/11/1111"
                        />


                    </Form.Item>

                  </Grid>
                  </InvisibleContent>

                  <InvisibleContent
                  visible={tipoDocumento === 'pj'}
                >
                  <Grid item sm={6} xs={12}>

                    <Form.Item
                      name="nome_fantasia"
                      label="Nome fantasia"
                     // hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Selecione uma forma de Contribuição',
                        },
                      ]}
                    >
                     <Input />
                    </Form.Item>



                  </Grid>

                  <Grid item sm={6} xs={12}>


                    <Form.Item
                      name="data_nascimento"
                      label="Data fundação"
                      rules={[
                        {
                          required: true,
                          message: 'Selecione um tipo de correspondencia',
                        },
                      ]}
                    >
                      <MaskedInput
                          type="date"
                          max={DATA}
                          mask="11/11/1111"
                        />


                    </Form.Item>

                  </Grid>
                  </InvisibleContent>




                </Grid>






                <Grid item sm={12} xs={12} style={{ paddingTop: 10 }}>
                  <ButtonComponent
                    color="primary"
                    //disabled={verificaTriagem === true}
                    loading={loadingUpdate}
                    fullWidth
                    type="submit"
                  >
                    <SaveOutlined style={{ marginRight: 10 }} /> Salvar
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </Spin>
      </Grid>




    </Grid>
  );
};

export default PerfilComponent;
